import { createModule } from '../createModule';

export const projectStatus = createModule('projectStatus', {
  url: 'project_status'
});